import { constructObjectDefault, constructObjectProduct } from '../helpers';
import { MAGALU_DOMAIN } from '../../../constants';

const productSchema = ({
  product = {},
  productRating = {},
  isList = false
}, domain = MAGALU_DOMAIN) => {
  if (!product || Object.keys(product).length === 0) return {};
  const objectDefault = constructObjectDefault(product, productRating, domain);
  const objectProductPage = isList ? {} : constructObjectProduct(product, productRating);
  return Object.assign({}, objectDefault, objectProductPage);
};

export default productSchema;